import React from "react";
import PropTypes from "prop-types";

export default function AddButton(props) {
  const {className, onClick, text, disabled} = props;
  return (
    <button className={"bold link--green font--12 flex flex--center bg-none border-none box-shadow-none "
      + (disabled ? "opacity-50" : "link")
      + (className ? " " + className : "")}
            onClick={disabled ? null : onClick}>
      <span className="ui-icon-plus ui-icon-plus--green ui-icon-plus--small margin-0"/>
      <span className="relative -top-05px">{text}</span>
    </button>
  )
}

AddButton.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  text: PropTypes.string.isRequired,
}
